const pad = (value: number): string => String(value).padStart(2, '0')

const formatDateTimePrefix = (date: Date): string =>
  `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}` +
  `${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`

/**
 * ToL運用管理（お知らせ・OTACメンテナンススケジュール）の項目IDを自動採番する。
 * フォーマット: yyyymmddHHmmss_NNN（作成日時14桁 + 連番3桁ゼロ埋め）
 *
 */
export const generateTolOperationsItemId = (usedIds: Iterable<string>): string => {
  const prefix = formatDateTimePrefix(new Date())
  const usedSet = new Set(usedIds)

  for (let i = 1; i <= 999; i++) {
    const candidate = `${prefix}_${String(i).padStart(3, '0')}`
    if (!usedSet.has(candidate)) {
      return candidate
    }
  }

  throw new Error('ID採番の上限に達しました')
}
